import { BOOLEAN_SELECT_LIST_ITEMS, Grid, GridBreak, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { StudentGroupFilter as StudentGroupFilterModel, StudentGroupFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentGroupFilter = (props: {
  filter: StudentGroupFilterModel;
  setFilter: (value: StudentGroupFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentGroupFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.studentGroups.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolField = () => {
    const propertyName = pn<StudentGroupFilterModel>("schoolIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.schools?.filter((x) => props.filter.schoolIds?.includes(x.id))}
        options={resource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const inactiveField = () => {
    const propertyName = pn<StudentGroupFilterModel>("inactive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.inactive)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.inactive = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {schoolField()}
      </Grid>

      <GridBreak />

      <Grid item xs={smallFieldBreakpoints}>
        {inactiveField()}
      </Grid>
    </Grid>
  );
};
